// Mirrors Lesson 1 (l1) in backend/course_content.py — keep in sync if the lesson text changes.
export const SAMPLE_LESSON = {
  kicker: "Lesson 1 · Free",
  title: "Becoming an Investigator of Your Own Mind",
  subtitle: "The Space Between Event and Reaction",
  coreQuestion: "What actually happened before my mind explained what happened?",
  steps: [
    { step: "Notice", label: "Core Question", q: "What can I describe about the event without adding what I think it meant?" },
    { step: "Explore", label: "Deeper Question", q: "What did my mind add to the event?" },
    { step: "Connect", label: "Therapeutic Bridge", q: "What question would help me understand the difference between what happened and what I concluded?" },
  ],
  lookFor: "Look for the boundary between observable information and interpretation. Do not force yourself to decide which interpretation is correct. First learn to see the difference.",
  carry: "The Connect question is the one you'd bring to a provider — written down, in your own words, before the appointment.",
  after: "You walk in with a question instead of a knot. Less alone in it, and less helpless in the gap between needing help and finding it.",
  cta: "Open Lesson 1 — it's free",
};

// Illustrative only — written to show the format of a finished entry. Not a learner's words.
export const SAMPLE_ENTRY = {
  label: "Sample entry · shows the format, not a real learner's words",
  notice: "He didn't answer my text for four hours. That is the whole event.",
  explore: "My mind added: he's pulling away, I did something wrong, this is how it always goes.",
  connect: "How do I tell the difference between someone being busy and someone pulling away — and why does my mind jump to the second so fast?",
  sheetTitle: "Questions I'd like to explore with my provider",
  sheetSource: "From Lesson 1 · Becoming an Investigator of Your Own Mind — Connect prompt",
};
